import { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface Crumb {
  label: string
  to?: string
}

/** Slim, minimalist breadcrumb trail. The last crumb is rendered as the
 *  current page (no link). */
export function Breadcrumbs({ items, className }: { items: Crumb[]; className?: string }) {
  return (
    <nav aria-label='Breadcrumb' className={cn('flex items-center gap-1 text-sm', className)}>
      {items.map((item, i) => {
        const isLast = i === items.length - 1
        return (
          <Fragment key={`${item.label}-${i}`}>
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className='text-muted-foreground hover:text-foreground transition-colors'
              >
                {item.label}
              </Link>
            ) : (
              <span className={cn(isLast ? 'font-medium text-foreground' : 'text-muted-foreground')}>
                {item.label}
              </span>
            )}
            {!isLast && (
              <ChevronRight className='h-3.5 w-3.5 text-muted-foreground/50 shrink-0' />
            )}
          </Fragment>
        )
      })}
    </nav>
  )
}
